import { useContext } from 'react';
import { AIPropertiesProcessingContext } from './AIPropertiesProcessingContextProvider';
export function useAIProcessingMetadata() {
  var _context$metadata;
  const context = useContext(AIPropertiesProcessingContext);
  return (_context$metadata = context === null || context === void 0 ? void 0 : context.metadata) !== null && _context$metadata !== void 0 ? _context$metadata : {};
}